var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.006,
    height: 24,
    viewBox: "0 0 24.006 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book_a_trial_class",
    "data-name": "book a trial class",
    transform: "translate(0 -0.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53270",
    "data-name": "Group 53270",
    transform: "translate(0.352 0.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53268",
    "data-name": "Group 53268",
    transform: "translate(0 3.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53263",
    "data-name": "Group 53263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24737",
    "data-name": "Path 24737",
    d: "M29.25,73.772A1.553,1.553,0,0,1,30.8,75.325V90.862a1.553,1.553,0,0,1-1.553,1.553H9.053A1.553,1.553,0,0,1,7.5,90.862V75.325a1.553,1.553,0,0,1,1.553-1.553Z",
    transform: "translate(-7.5 -73.772)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24738",
    "data-name": "Path 24738",
    d: "M58.871,106.895a.387.387,0,0,1,.379.306,1.677,1.677,0,0,0,1.264,1.263.387.387,0,0,1,.305.379v11.641a.387.387,0,0,1-.305.379,1.677,1.677,0,0,0-1.264,1.263.387.387,0,0,1-.379.306h-16.3a.387.387,0,0,1-.379-.306,1.677,1.677,0,0,0-1.264-1.263.387.387,0,0,1-.305-.379V108.843a.387.387,0,0,1,.305-.379,1.677,1.677,0,0,0,1.264-1.263.387.387,0,0,1,.379-.306Z",
    transform: "translate(-39.07 -105.342)",
    fill: "#ebf5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24739",
    "data-name": "Path 24739",
    d: "M449.455,73.772h-1.078a1.553,1.553,0,0,1,1.553,1.553V90.862a1.553,1.553,0,0,1-1.553,1.553h1.078a1.553,1.553,0,0,0,1.553-1.553V75.325A1.553,1.553,0,0,0,449.455,73.772Z",
    transform: "translate(-427.706 -73.772)",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24740",
    "data-name": "Path 24740",
    d: "M409.541,108.464a1.677,1.677,0,0,1-1.264-1.263.387.387,0,0,0-.379-.306H406.82a.387.387,0,0,1,.379.306,1.677,1.677,0,0,0,1.264,1.263.387.387,0,0,1,.305.379v11.641a.387.387,0,0,1-.305.379,1.677,1.677,0,0,0-1.264,1.263.387.387,0,0,1-.379.306H407.9a.387.387,0,0,0,.379-.306,1.677,1.677,0,0,1,1.264-1.263.387.387,0,0,0,.305-.379V108.843a.387.387,0,0,0-.305-.379Z",
    transform: "translate(-388.097 -105.342)",
    fill: "#d3dcfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53264",
    "data-name": "Group 53264",
    transform: "translate(8.542 5.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24741",
    "data-name": "Path 24741",
    d: "M195.514,191.406h-5.462a.375.375,0,0,1-.375-.375v-.8a.375.375,0,0,1,.375-.375h5.462a.375.375,0,0,1,.375.375v.8A.375.375,0,0,1,195.514,191.406Z",
    transform: "translate(-189.677 -189.853)",
    fill: "#4fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24742",
    "data-name": "Path 24742",
    d: "M292.248,189.853H291.17a.375.375,0,0,1,.375.375v.8a.375.375,0,0,1-.375.375h1.078a.375.375,0,0,0,.375-.375v-.8A.375.375,0,0,0,292.248,189.853Z",
    transform: "translate(-286.411 -189.853)",
    fill: "#1886ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53267",
    "data-name": "Group 53267",
    transform: "translate(11.911 8.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53266",
    "data-name": "Group 53266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24743",
    "data-name": "Path 24743",
    d: "M309.914,406.519l.273.545a.776.776,0,0,1,.082.347v3.311a.388.388,0,0,1-.511.368l-1.042-.347-.654-.6a.388.388,0,0,0-.246,0l-.654.6-1.042.347a.388.388,0,0,1-.511-.368v-3.311a.777.777,0,0,1,.082-.347l.272-.545Z",
    transform: "translate(-303.544 -399.73)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24744",
    "data-name": "Path 24744",
    d: "M375.768,407.064l-.272-.545h-1.078l.272.545a.776.776,0,0,1,.082.347v3.311a.386.386,0,0,1-.038.167l.605.2a.388.388,0,0,0,.511-.368v-3.311A.776.776,0,0,0,375.768,407.064Z",
    transform: "translate(-369.125 -399.73)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24745",
    "data-name": "Path 24745",
    d: "M340.284,406.519h-1.553v4.224l.654-.218a.389.389,0,0,1,.246,0l.654.218Z",
    transform: "translate(-335.112 -399.73)",
    fill: "#ebf5fc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_787",
    "data-name": "Ellipse 787",
    cx: 3.106,
    cy: 3.106,
    r: 3.106,
    transform: "translate(0 4.392) rotate(-45)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53265",
    "data-name": "Group 53265",
    transform: "translate(2.843 1.286)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_788",
    "data-name": "Ellipse 788",
    cx: 1.553,
    cy: 1.553,
    r: 1.553,
    transform: "translate(0 1.553)",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24746",
    "data-name": "Path 24746",
    d: "M344.332,289.147a3.124,3.124,0,0,0-.539.048,3.106,3.106,0,0,1,0,6.117,3.106,3.106,0,1,0,.539-6.164Z",
    transform: "translate(-342.779 -289.147)",
    fill: "#ffb332"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53269",
    "data-name": "Group 53269",
    transform: "translate(3.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24747",
    "data-name": "Path 24747",
    d: "M180.559,38.928h-7.017a.375.375,0,0,1-.375-.375V33.139h7.768v5.414A.375.375,0,0,1,180.559,38.928Z",
    transform: "translate(-169.283 -31.937)",
    fill: "#3c58a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24748",
    "data-name": "Path 24748",
    d: "M308.208,33.139v5.414a.375.375,0,0,1-.375.375h1.078a.375.375,0,0,0,.375-.375V33.139Z",
    transform: "translate(-297.635 -31.937)",
    fill: "#2a428c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24749",
    "data-name": "Path 24749",
    d: "M105.493,9.058H90.708a.375.375,0,0,1-.375-.375v-.8a.375.375,0,0,1,.375-.375h14.785a.375.375,0,0,1,.375.375v.8A.375.375,0,0,1,105.493,9.058Z",
    transform: "translate(-90.333 -7.505)",
    fill: "#3c58a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24750",
    "data-name": "Path 24750",
    d: "M391.745,7.505h-1.078a.375.375,0,0,1,.375.375v.8a.375.375,0,0,1-.375.375h1.078a.375.375,0,0,0,.375-.375v-.8A.375.375,0,0,0,391.745,7.505Z",
    transform: "translate(-376.585 -7.505)",
    fill: "#2a428c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24751",
    "data-name": "Path 24751",
    d: "M373.521,107.682a.777.777,0,0,0-.814-.776.791.791,0,0,0-.739.8v1.143a.388.388,0,0,0,.388.388h.777a.388.388,0,0,0,.388-.388Z",
    transform: "translate(-358.762 -102.245)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24752",
    "data-name": "Path 24752",
    d: "M377.535,106.906a.757.757,0,0,0-.5.221.774.774,0,0,1,.234.555v1.165a.388.388,0,0,1-.238.358.388.388,0,0,0,.151.03h.777a.388.388,0,0,0,.388-.388v-1.165A.777.777,0,0,0,377.535,106.906Z",
    transform: "translate(-363.591 -102.245)",
    fill: "#ffb332"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53271",
    "data-name": "Group 53271",
    transform: "translate(0 0.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24753",
    "data-name": "Path 24753",
    d: "M22.1,3.167H18.563V2.319h.826a.728.728,0,0,0,.727-.727V.79a.728.728,0,0,0-.727-.727H16.6a.352.352,0,1,0,0,.7H17.86v.85H4.609a.023.023,0,0,1-.023-.023V.79A.023.023,0,0,1,4.609.766H15.16a.352.352,0,1,0,0-.7H4.609A.728.728,0,0,0,3.883.79v.8a.728.728,0,0,0,.727.727H7.765v.848H1.9A1.907,1.907,0,0,0,0,5.072V20.609a1.907,1.907,0,0,0,1.9,1.9h2.4a.352.352,0,1,0,0-.7H1.9a1.2,1.2,0,0,1-1.2-1.2V5.072a1.2,1.2,0,0,1,1.2-1.2h5.86v.85H3.853a.743.743,0,0,0-.723.585,1.323,1.323,0,0,1-.993.992.742.742,0,0,0-.584.723V18.661a.742.742,0,0,0,.584.723,1.323,1.323,0,0,1,.993.992.743.743,0,0,0,.723.585H13.977v.85H5.714a.352.352,0,1,0,0,.7h8.263v.809a.74.74,0,0,0,.974.7l1.7-.565a.036.036,0,0,1,.023,0l1.7.565a.74.74,0,0,0,.974-.7v-.809H22.1a1.907,1.907,0,0,0,1.9-1.9V5.072a1.907,1.907,0,0,0-1.9-1.9ZM18.563.766h.826a.023.023,0,0,1,.023.023v.8a.023.023,0,0,1-.023.023h-.826Zm-.7,2.4H16.234V2.319H17.86Zm-.073,2.7a.441.441,0,0,1,.4-.446h.021a.425.425,0,0,1,.425.425V7.015a.037.037,0,0,1-.037.037h-.776a.037.037,0,0,1-.037-.037V5.872ZM16.234,4.72v-.85H17.86v.85ZM8.468,6.2H15.53v.826a.023.023,0,0,1-.023.023H8.492a.023.023,0,0,1-.023-.023ZM15.53,2.319V5.5H8.468V2.319ZM3.853,20.258a.036.036,0,0,1-.035-.028A2.019,2.019,0,0,0,2.283,18.7a.035.035,0,0,1-.027-.035V7.02a.035.035,0,0,1,.027-.035A2.019,2.019,0,0,0,3.818,5.452a.036.036,0,0,1,.035-.028H7.765v1.6a.728.728,0,0,0,.727.727h7.015a.728.728,0,0,0,.727-.727v-1.6h.939a1.171,1.171,0,0,0-.089.449V7.015a.741.741,0,0,0,.74.74H18.6a.741.741,0,0,0,.74-.74V5.85a1.128,1.128,0,0,0-.085-.427h.9a.036.036,0,0,1,.035.028,2.019,2.019,0,0,0,1.535,1.534.035.035,0,0,1,.027.035V18.661a.035.035,0,0,1-.027.035,2.019,2.019,0,0,0-1.535,1.534.036.036,0,0,1-.035.028H19.34v-.245a1.133,1.133,0,0,0-.119-.5l-.154-.307a3.451,3.451,0,0,0-.317-5.228h.238a.352.352,0,1,0,0-.7H5.011a.352.352,0,1,0,0,.7h9.556a3.485,3.485,0,0,0-.794.85H7.34a.352.352,0,1,0,0,.7h6.075A3.452,3.452,0,0,0,14.25,19.2l-.154.307a1.133,1.133,0,0,0-.119.5v.245Zm12.805-.78a2.754,2.754,0,0,1-.139-5.505H16.8a2.754,2.754,0,0,1-.139,5.505Zm-1.93,3.88a.037.037,0,0,1-.048-.035V20.013a.427.427,0,0,1,.045-.19l.088-.177a3.446,3.446,0,0,0,.716.345v3.1Zm1.7-.565-.191.064v-2.7a3.349,3.349,0,0,0,.85,0v2.7l-.191-.064A.745.745,0,0,0,16.424,22.793Zm2.2.56a.035.035,0,0,1-.033.005l-.8-.267v-3.1a3.441,3.441,0,0,0,.716-.345l.089.177a.427.427,0,0,1,.045.19v3.311a.034.034,0,0,1-.015.03ZM23.3,20.609a1.2,1.2,0,0,1-1.2,1.2H19.34v-.85h.813a.743.743,0,0,0,.723-.585,1.323,1.323,0,0,1,.993-.992.742.742,0,0,0,.584-.723V7.02a.741.741,0,0,0-.584-.723,1.324,1.324,0,0,1-.993-.992.743.743,0,0,0-.723-.585h-1.59v-.85H22.1a1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(0 -0.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24754",
    "data-name": "Path 24754",
    d: "M462.352,99.47h-.194a.352.352,0,1,0,0,.7h.194a.352.352,0,1,0,0-.7Z",
    transform: "translate(-440.154 -94.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24755",
    "data-name": "Path 24755",
    d: "M31.4,100.173H31.6a.352.352,0,0,0,0-.7H31.4a.352.352,0,1,0,0,.7Z",
    transform: "translate(-29.597 -94.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24756",
    "data-name": "Path 24756",
    d: "M31.4,430.777a.352.352,0,0,0,0,.7H31.6a.352.352,0,0,0,0-.7Z",
    transform: "translate(-29.597 -410.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24757",
    "data-name": "Path 24757",
    d: "M462.353,430.777h-.194a.352.352,0,1,0,0,.7h.194a.352.352,0,1,0,0-.7Z",
    transform: "translate(-440.155 -410.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24758",
    "data-name": "Path 24758",
    d: "M316.574,314.77a1.9,1.9,0,1,0,1.9,1.9A1.907,1.907,0,0,0,316.574,314.77Zm0,3.106a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,316.574,317.876Z",
    transform: "translate(-299.915 -300.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24759",
    "data-name": "Path 24759",
    d: "M346.268,347.893h-.194a.352.352,0,1,0,0,.7h.194a.352.352,0,1,0,0-.7Z",
    transform: "translate(-329.512 -331.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24760",
    "data-name": "Path 24760",
    d: "M182.9,184.609h5.462a.728.728,0,0,0,.727-.727v-.8a.728.728,0,0,0-.727-.727H182.9a.728.728,0,0,0-.727.727v.8A.728.728,0,0,0,182.9,184.609Zm-.023-1.53a.023.023,0,0,1,.023-.023h5.462a.023.023,0,0,1,.023.023v.8a.023.023,0,0,1-.023.023H182.9a.023.023,0,0,1-.023-.023Z",
    transform: "translate(-173.635 -173.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24761",
    "data-name": "Path 24761",
    d: "M99.721,249.3H113.7a.352.352,0,0,0,0-.7H99.721a.352.352,0,0,0,0,.7Z",
    transform: "translate(-94.71 -236.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24762",
    "data-name": "Path 24762",
    d: "M102.05,381.016h-2.33a.352.352,0,0,0,0,.7h2.33a.352.352,0,1,0,0-.7Z",
    transform: "translate(-94.71 -363.154)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBook);
export default __webpack_public_path__ + "static/media/menu-book.311a90cc7c74aa47e8f4422b901af78c.svg";
export { ForwardRef as ReactComponent };